<!-- financial-ops-history.component.html -->
<p-dataView [value]="versionEvents" layout="list" [paginator]="false">
  <ng-template #list let-items>
    <div class="grid grid-cols-12 gap-4 grid-nogutter">
      <div
        class="col-span-12 w-full"
        *ngFor="let version of items; let last = last"
      >
        <div class="p-6 flex flex-col gap-4">
          <!-- Basic Info: versionId, timestamp, commitMessage, rollback button -->
          <div style="width: 400px">
            <h3>Financial Ops Version {{ version.versionId }}</h3>
            <span class="text-lg text-300">
              {{ version.timestamp | date: "long" }}
            </span>

            <p-card *ngIf="version.commitMessage">
              <markdown [data]="version.commitMessage"></markdown>
            </p-card>

            <p-button
              [disabled]="isLatestVersion(version)"
              *ngIf="!version.isRollback"
              label="Rollback"
              (click)="rollbackVersion(version.versionId, $event)"
            ></p-button>
          </div>

          <!-- Accordion for inputChanges / outputChanges -->
          <p-accordion class="w-full">
            <!-- Input Changes -->
            <p-accordion-panel value="0">
              <p-accordion-header>Input Changes</p-accordion-header>
              <p-accordion-content>
                <div *ngIf="isEmpty(version.inputChanges)">
                  <em>No input changes in this version.</em>
                </div>
                <ng-container *ngIf="!isEmpty(version.inputChanges)">
                  <table class="changes-table">
                    <thead>
                      <tr>
                        <th>Field</th>
                        <th>Old</th>
                        <th>New</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let key of objectKeys(version.inputChanges)">
                        <td>{{ key }}</td>
                        <td>
                          {{ formatValue(version.inputChanges[key].oldValue) }}
                        </td>
                        <td>
                          {{ formatValue(version.inputChanges[key].newValue) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </ng-container>
              </p-accordion-content>
            </p-accordion-panel>

            <!-- Output Changes -->
            <p-accordion-panel value="1">
              <p-accordion-header>Output Changes</p-accordion-header>
              <p-accordion-content>
                <div *ngIf="isEmpty(version.outputChanges)">
                  <em>No output changes in this version.</em>
                </div>
                <ng-container *ngIf="!isEmpty(version.outputChanges)">
                  <table class="changes-table">
                    <thead>
                      <tr>
                        <th>Field</th>
                        <th>Old</th>
                        <th>New</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let key of objectKeys(version.outputChanges)">
                        <td>{{ key }}</td>
                        <td>
                          {{ formatValue(version.outputChanges[key].oldValue) }}
                        </td>
                        <td>
                          {{ formatValue(version.outputChanges[key].newValue) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </ng-container>
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        </div>
        <hr *ngIf="!last" class="my-2" />
      </div>
    </div>
  </ng-template>
</p-dataView>
